import { render, staticRenderFns } from "./shipmentDocument.vue?vue&type=template&id=d88efd4c&scoped=true&"
import script from "./shipmentDocument.vue?vue&type=script&lang=js&"
export * from "./shipmentDocument.vue?vue&type=script&lang=js&"
import style0 from "./shipmentDocument.vue?vue&type=style&index=0&id=d88efd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88efd4c",
  null
  
)

export default component.exports